import axios from 'axios';
import { M_URL } from '../../../constants';
import { FAILED_STATUS } from './config';

const authHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

// Avto-davom ishlatadigan so'rovlar. Testlarda butunlay mock bilan almashtiriladi.
export const autoContinueApi = {
  // GET /generatings-history?status=failed — GenerateHistory sahifasidagi bilan bir xil
  async listFailed({ skip, limit }) {
    const params = new URLSearchParams({ skip, limit, status: FAILED_STATUS });
    const res = await fetch(`${M_URL}/generatings-history?${params}`, { headers: authHeaders() });
    if (!res.ok) throw new Error(`generatings-history: ${res.status}`);
    return res.json();
  },

  // GET /video-status/{task_id} — continue oldidan joriy holatni tekshirish
  async getStatus(taskId) {
    const res = await fetch(`${M_URL}/video-status/${encodeURIComponent(taskId)}`, { headers: authHeaders() });
    if (!res.ok) throw new Error(`video-status: ${res.status}`);
    return res.json();
  },

  // POST /video-generate/continue/{task_id} — qo'lda "Davom etish" tugmasi yuboradigan so'rovning aynan o'zi
  postContinue(taskId) {
    return axios.post(
      `${M_URL}/video-generate/continue/${taskId}`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
        },
      }
    );
  },
};
